"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _SeatsPicker = _interopRequireDefault(require("../common/SeatsPicker"));

var _BundlePage = require("./BundlePage");

var _Terms = require("self-service-api/constants/Terms");

var _SalesPlanButton = _interopRequireDefault(require("./SalesPlanButton"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _AccordionTransition = _interopRequireDefault(require("UIComponents/transitions/AccordionTransition"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _HubBundleHeader = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/HubBundleHeader"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "SalesHubBundle__ButtonFlex",
  componentId: "sc-1r0urrw-0"
})(["", ";"], _responsiveBreakpoints.default.phone(_templateObject()));

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "SalesHubBundle__ButtonWrapper",
  componentId: "sc-1r0urrw-1"
})(["width:100%;"]);

var StyledAccordionTransition = (0, _styledComponents.default)(_AccordionTransition.default).withConfig({
  displayName: "SalesHubBundle__StyledAccordionTransition",
  componentId: "sc-1r0urrw-2"
})(["overflow:visible !important;"]);

function SalesHubBundle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var salesPlanSelected = state.salesPlanSelected,
      salesUnits = state.salesUnits;
  return _react.default.createElement("div", {
    className: "m-bottom-12",
    "data-selenium-id": "sales-hub-bundle-root",
    "data-merch-id": salesPlanSelected,
    "data-units": salesUnits,
    "data-units-merch-id": salesPlanSelected && merchandiseMap[salesPlanSelected].additionalUnitMerchId
  }, _react.default.createElement(_HubBundleHeader.default, {
    title: title,
    subtitle: subtitle,
    hub: _Hubs.default.HUB_SALES,
    gaClassName: (0, _publicPageUrls.getGAClassName)('bundle-pricing-salescompare')
  }), _react.default.createElement(ButtonFlex, {
    className: "m-top-6"
  }, _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_SalesPlanButton.default, {
    edition: Editions.STARTER,
    merchandiseId: _MerchandiseIds.PRODUCT_SALES_STARTER_MAR_2020
  })), _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_SalesPlanButton.default, {
    edition: Editions.PROFESSIONAL,
    merchandiseId: _MerchandiseIds.PRODUCT_SALES_PROFESSIONAL_NOV_2019
  })), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(_SalesPlanButton.default, {
    edition: Editions.ENTERPRISE,
    merchandiseId: _MerchandiseIds.PRODUCT_SALES_ENTERPRISE
  }))), _react.default.createElement(StyledAccordionTransition, {
    open: !!salesPlanSelected
  }, _react.default.createElement("div", {
    className: "m-top-10"
  }, _react.default.createElement(_SeatsPicker.default, {
    merchandiseId: salesPlanSelected,
    additionalUnitQuantity: salesUnits,
    onChange: function onChange(value) {
      return setState({
        salesUnits: value
      });
    },
    term: _Terms.MONTHLY
  }))));
}

var _default = SalesHubBundle;
exports.default = _default;
module.exports = exports.default;